<template>
    <div class="mt-2">
        <div>
            <h2 class="text-xl font-semibold text-center uppercase">Cotización</h2>
        </div>

        <div class="grid grid-cols-3 text-sm my-2">
            <div class="text-left">Nº cotización:</div>
            <div class="text-right col-span-2">{{ datos.numeroCotz }}</div>

            <div class="text-left">Fecha:</div>
            <div class="text-right col-span-2">{{ datos.fecha }}</div>

            <div class="text-left">Cliente:</div>
            <div class="text-right col-span-2">{{ datos.nombre }}</div>

            <div class="text-left">Asesor:</div>
            <div class="text-right col-span-2">{{ datos.nombreVendedor }}</div>
            
            <template v-if="datos.profesional">
                <div class="text-left">Profesional:</div>
                <div class="text-right col-span-2">{{ datos.profesional }}</div>
            </template>
            
            <template v-if="datos.laboratorio">
                <div class="text-left">Laboratorio:</div>
                <div class="text-right col-span-2">{{ datos.laboratorio }}</div>
            </template>
        </div>

        <div class="grid grid-cols-3 text-sm my-2 border-t border-gray-200 pt-2">
            <div class="text-left col-span-3 text-base font-bold mb-1 uppercase">
                Detalle lentes
            </div>
            
            <template v-for="(lente, indice) in datos.lentes" :key="indice">
                <div class="text-left text-lg col-span-3 font-semibold mt-2 border-b border-gray-100">
                    {{ `${lente.tipo}:` }}
                </div>

                <div class="text-left">Armazón:</div>
                <div class="text-right col-span-2">{{ lente.armazon }}</div>

                <div class="text-left">Cristal:</div>
                <div class="text-right col-span-2">{{ lente.cristal }}</div>

                <div class="text-left">Filtro:</div>
                <div class="text-right col-span-2">{{ lente.filtro }}</div>

                <template v-if="lente.tipo == 'Multifocal'">
                    <div class="text-left">T.multifocal:</div>
                    <div class="text-right col-span-2">{{ lente.tipoMultifocal }}</div>
                </template>

                <div class="text-left font-medium">Precio Lente:</div>
                <div class="text-right col-span-2 font-medium">{{ `$ ${this.formatearCifra(lente.valor)}` }}</div>
            </template>
        </div>

        <div class="grid grid-cols-3 text-sm my-2 border-t border-gray-400 pt-2">
            <div class="text-left uppercase">Subtotal:</div>
            <div class="text-right col-span-2">{{ `$ ${this.formatearCifra(datos.total)}` }}</div>
            
            <template v-if="datos.descuentoPorcentaje > 0">
                <div class="text-left italic text-gray-600">Descuento ({{ datos.descuentoPorcentaje }}%):</div>
                <div class="text-right col-span-2 italic text-gray-600">{{ `- $ ${this.formatearCifra(datos.montoDescuento)}` }}</div>
            </template>
            
            <div class="text-left text-lg font-bold uppercase mt-1">Total:</div>
            <div class="text-right col-span-2 text-lg font-bold mt-1">{{ `$ ${this.formatearCifra(datos.totalFinal || datos.total)}` }}</div>
        </div>
    </div>
</template>

<script>
import { separarPorMiles } from "@/utils/helpers";

export default {
    methods: {
        formatearCifra(cifra) {
            return separarPorMiles(cifra);
        }
    },
    props: {
        datos: {
            type: Object,
            default: null
        }
    }
}
</script>